<template>
  <div class="home">
    <div class="root-index-page" @mousemove="handleMove($event)">
      <div class="banner">
        <div class="doodles"></div>
        <div class="book_box">
          <div class="book" id="scene">
            <img
              data-depth="0.2"
              v-for="img in images"
              :key="img"
              :src="img"
              :style="
                'transform: translate3d(' +
                tranforml +
                'px, ' +
                tranformr +
                'px, 0px);'
              "
            />
          </div>
          <h1 class="text-center text-white">智慧课本</h1>
          <div class="text-center subtitle mt-2">
            智能化、立体化、互动性、自主性<br /><br />
          </div>
          <div class="text-center enter_but mt-2">
            <a href="/resources">开始体验</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      images: [
        require('@/assets/images/courses/book.png'),
        require('@/assets/images/courses/cards.png'),
        require('@/assets/images/courses/dodecahedron.png'),
        require('@/assets/images/courses/snub-dodecahedron.png'),
        require('@/assets/images/courses/variable-1.png'),
        require('@/assets/images/courses/actions.png'),
        require('@/assets/images/courses/die-2.png'),
        require('@/assets/images/courses/trumpet.png'),
        require('@/assets/images/courses/die-1.png'),
        require('@/assets/images/courses/nautilus.png'),
        require('@/assets/images/courses/variable-2.png'),
      ],
      tranforml: 0,
      tranformr: 0,
    }
  },
  methods: {
    handleMove(e) {
      this.tranforml = (e.clientX - window.innerHeight / 2) * 0.01
      this.tranformr = (e.clientY - window.innerHeight / 2) * 0.01
    },
  },
}
</script>

<style lang="scss" scoped>
.root-index-page {
  .banner {
    overflow: hidden;
    height: calc(100% - 34px);
    width: 100%;
    background: #181824;
    background-image: url('../assets/images/courses/tiles-1.png'),
      linear-gradient(180deg, #031b3e, #080808);
    background-size: 240px 240px, 100% 100%;
    position: absolute;

    .doodles {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      will-change: transform;
      background: url('../assets/images/courses/doodles.png');
      opacity: 0.1;
      background-size: contain;
    }

    .book_box {
      position: relative;
      top: 50%;
    }

    .book {
      width: 100%;
      max-width: 720px;
      height: 32vh;
      position: absolute;
      top: 0%;
      left: 50%;
      user-select: none;
      pointer-events: none;
      transform: translate(-50%, -100%) translate3d(0px, 0px, 0px)
        rotate(0.0001deg);
      transform-style: preserve-3d;
      backface-visibility: hidden;
      pointer-events: none;

      img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        transform-origin: center 65%;
      }

      .first-img {
        position: relative;
      }
    }

    .subtitle {
      font-size: 16px;
      color: #6d7382;
    }

    .enter_but {
      width: 150px;
      margin-left: calc(50% - 75px);
      padding: 8px;
      border-radius: 10px;
      background: #15beeb;
      box-shadow: 2px 3px 1px 0px rgba(0, 0, 0, 0.2);
      color: #fff;
      font-size: 20px;
      cursor: pointer;

      a {
        color: #fff;
      }
    }

    .enter_but:hover {
      background: #077aeb;
    }
  }

  .sort {
    .sort-item {
      padding: 10px 0px;
      float: left;
      display: block;
      text-align: center;
      width: 100%;
      color: #6d7382;
      transition: all 0.3s ease;

      .icon {
        font-size: 32px;
      }

      .sort-name {
        display: block;
        margin-top: 5px;
      }

      &:hover {
        background: #f2f5f9;
        box-shadow: 0px 2px 2px rgba(69, 87, 113, 0.2) inset;
        border-radius: 3px;

        .icon {
          color: #0a90cc;
        }

        .sort-name {
          color: #333;
        }
      }

      &.active {
        background: #f2f5f9;
        box-shadow: 0px 2px 2px rgba(69, 87, 113, 0.2) inset;
        border-radius: 3px;

        .icon {
          color: #0a90cc;
        }

        .sort-name {
          color: #333;
        }
      }
    }
  }

  .ivu-select {
    margin-top: 30px;

    .ivu-select-selection {
      border: 1px solid #aaa;
    }
  }

  .course-close {
    filter: grayscale(100%);
    opacity: 0.66;
  }
}
</style>
